import React from 'react';
import { AccessibilityIcon, BlocksIcon, ClipboardListIcon, CompassIcon, LineChartIcon, PuzzleIcon } from 'lucide-react';
import { volumes, VolumeIcon } from '../data/toolkit';
import { CtaButton } from './CtaButton';
import { FrameworkFlow } from './FrameworkFlow';
const icons: Record<VolumeIcon, typeof ClipboardListIcon> = {
  assess: ClipboardListIcon,
  plan: CompassIcon,
  treat: PuzzleIcon,
  pediatric: BlocksIcon,
  adult: AccessibilityIcon,
  track: LineChartIcon
};
export function VolumesSection() {
  return <section className="border-y border-navy-line bg-ivory py-11 sm:py-14" aria-labelledby="volumes-title" data-id="element-114" data-mp="3c57g0aq9bfz1">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-5xl" data-id="element-115" data-mp="3pwvps7d19scu">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-116" data-mp="3l2ztd9cf4djs">
          The complete OT Clinical Toolkit™
        </p>
        <h2 id="volumes-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-117" data-mp="2sfx1h028z12i">
          6 professional volumes.
          <span className="mt-1 block text-navy-muted" data-id="element-118" data-mp="2eebosc91tf0p">
            One connected clinical workflow.
          </span>
        </h2>
        <p className="mt-4 text-[0.98rem] leading-relaxed text-navy-muted lg:max-w-2xl" data-id="element-119" data-mp="2j6mr1lr9hcwf">
          Instead of collecting more disconnected information, build one
          practical reference system you can return to throughout the clinical
          process.
        </p>

        <ol className="mt-6 grid gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-120" data-mp="1vf7lzl83ohhh">
          {volumes.map(volume => {
          const Icon = icons[volume.icon];
          return <li key={volume.number} className="flex h-full flex-col rounded-xl border border-navy-line bg-white p-4 sm:p-5" data-id="element-121" data-mp="24g5rk7y6sx26">
                <div className="flex items-center justify-between gap-3 border-b border-navy-line pb-3" data-id="element-122" data-mp="3bw256ke83lwk">
                  <div className="flex items-baseline gap-2" data-id="element-123" data-mp="3fxfb0uhbfp3h">
                    <span className="font-display text-[1.6rem] font-semibold leading-none text-navy" data-id="element-124" data-mp="1gphxv8yltge5">
                      {volume.number.toString().padStart(2, '0')}
                    </span>
                    <span className="text-[0.62rem] font-bold uppercase tracking-[0.16em] text-teal" data-id="element-125" data-mp="1pq7pe0gu0km2">
                      {volume.stage}
                    </span>
                  </div>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-light text-teal-deep" data-id="element-126" data-mp="x3v9cngtz5rl">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="t32yxqw82utq" />
                  </span>
                </div>

                <h3 className="mt-3 text-[0.98rem] font-semibold leading-snug text-navy" data-id="element-128" data-mp="16uhjw39ox63f">
                  {volume.title}
                </h3>
                <p className="mt-1.5 text-[0.85rem] leading-relaxed text-navy-muted" data-id="element-129" data-mp="ebkar5t7ltza">
                  {volume.benefit}
                </p>

                <ul className="mt-3.5 space-y-1.5 border-t border-navy-line pt-3.5" data-id="element-130" data-mp="9czcvd1fjme0">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-[0.82rem] font-medium leading-snug text-navy" data-id="element-131" data-mp="2pr2r9qr9yt6q">
                      <span className="mt-[0.45rem] h-1 w-1 shrink-0 rounded-full bg-sand" aria-hidden="true" data-id="element-132" data-mp="2gz0sry0rnmz3" />
                      {item}
                    </li>)}
                </ul>
              </li>;
        })}
        </ol>

        <div className="mt-7 border-t border-navy-line pt-7 text-center" data-id="element-133" data-mp="2ur75fa4pnbts">
          <p className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-navy" data-id="element-134" data-mp="2zp8q1zhsbj7d">
            One system. One clinical workflow.
          </p>
          <FrameworkFlow className="mt-3" data-id="element-135" data-mp="1j9nxx5k3kmpf" />
          <p className="mx-auto mt-4 max-w-[34rem] text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-136" data-mp="1oabzum9v6nyf">
            Move from initial observation to intervention and progress tracking
            without rebuilding your clinical workflow from scratch.
          </p>
          <CtaButton label="Get the complete toolkit" variant="teal" className="mx-auto mt-5 sm:w-auto" data-id="element-137" data-mp="1yrp6yv6lqaj7" />
        </div>
      </div>
    </section>;
}